import { AutogenModelCommission, AutogenRowCommission } from "./autogen/AutogenModelCommission";

export class ModelCommission extends AutogenModelCommission<RowCommission> {
	constructor() {
		super(RowCommission);
	}
}

export class RowCommission extends AutogenRowCommission {
}